import { render, staticRenderFns } from "./ConfirmacionEliminar.vue?vue&type=template&id=3de564cb&"
import script from "./ConfirmacionEliminar.vue?vue&type=script&lang=ts&"
export * from "./ConfirmacionEliminar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports